<template>
  <div id="app">
    <img class="app-logo" alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="杭州银贝信息咨询有限公司"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.app-logo {
  width: 200px;
  height: 200px;
}
</style>
